import { createSlice } from "@reduxjs/toolkit";

export const pageSlice = createSlice({
    name: "page",
    initialState: {
        page: "COMP_CONF",
        showLoading: true,
        showMsg: false,
        msgContent: {
            title: "",
            message: ""
        },
        msgId: null,
        msgResult: false
    },
    reducers: {
        openCompanyConf: (state) => {
            return {
                ...state,
                page: "COMP_CONF"
            };
        },
        openGeneralReg: (state) => {
            return {
                ...state,
                page: "GEN_REG"
            };
        },
        openAppKey: (state) => {
            return {
                ...state,
                page: "APP_KEY"
            };
        },
        showLoading: (state) => {
            return {
                ...state,
                showLoading: true
            };
        },
        hideLoading: (state) => {
            return {
                ...state,
                showLoading: false
            };
        },
        showMsg: (state, action) => {
            const {
                title,
                message
            } = action.payload;

            const msgId = action.payload.msgId !== undefined ? action.payload.msgId : null;

            return {
                ...state,
                showMsg: true,
                msgContent: {
                    title: title,
                    message: message
                },
                msgId: msgId,
                msgResult: false
            };
        },
        hideMsg: (state) => {
            return {
                ...state,
                showMsg: false,
                msgContent: {
                    title: "",
                    message: ""
                },
                msgId: null,
                msgResult: false
            };
        },
        confirmMsg: (state) => {
            return {
                ...state,
                msgResult: true
            };
        },
        requestLogout: (state) => {
            return {
                ...state,
                page: "LOGOUT"
            };
        },
        logoutComplete: (state) => {
            return {
                ...state,
                page: "COMP_CONF"
            };
        }
    }
});

export const { 
    openCompanyConf,
    openGeneralReg,
    openAppKey,
    showLoading,
    hideLoading,
    showMsg,
    hideMsg,
    confirmMsg,
    requestLogout,
    logoutComplete
 } = pageSlice.actions;

export default pageSlice.reducer;

export const pageSelector = (state) => state.page;